<template lang="pug">
.fixedHot(
    :style="`backgroundImage:url(${src});width:${pxToRem(w)};height:${pxToRem(h)};left:${pxToRem(l)};top:${pxToRem(t)};`"
    @click="onfunc"
    :class="outline?'showOutline':''"
)
    .inner(v-if="type==='blank'")
        slot

    

</template>

<script>
//两个按钮背景图片切换
// import { mapState } from 'vuex'
//components/common
// Hot(type='blank' :func="()=>ChangeUrl(0)" v-show="current===1" l="2534" t="800" w="1054" h="588")
export default {
    props:{
        type: {default: ''},
        bgsrc: {default: ''},
        bgsrc2: {default: ''},
        func: Function,
        w:{default: 80},
        h:{default: 80},
        l:{default: 'auto'},
        t:{default: 'auto'},
        outline:{default: false}
    },
    data(){
        return{
            isSel: false,
        }
    },
    computed:{
        src(){
            return this.isSel?this.bgsrc2:this.bgsrc
        }
        // thisLang(){
        //     return this.lang==='en/'?'en/':'cn/'
        // },
        // ...mapState('app',["lang"])
    },
    methods:{
        pxToRem(px){
            return `${px/14*0.5}rem`
        },
        onfunc(){
            if(this.func)this.func()
            this.isSel=!this.isSel
        },
        setSelected(bl){
            this.isSel=bl
        },
        getSelected(){
            return this.isSel
        }
    }
}
</script>

<style lang="sass" scoped>
@import '@/styles/common'
.fixedHot
    position: absolute
    cursor: pointer
    line-height: pxToRem(80)
    background-size: contain
    background-repeat: no-repeat
    // border-radius: 100%
    // display: inline-block
    // margin: pxToRem(20)
    
    // &:hover
        // opacity: 0.6
    .inner
        // text-align: center
        // color: #a1d2d9
        color: white
        font-size: pxToRem(36)
        height: 100%
        display: flex
        align-items: center
        justify-content: center
        font-weight: 300
    &.showOutline
        border: solid 5px #f00
        background-color: rgba(1,0,0,0.6)


</style>